/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface TopicDetectionError
 */
export interface TopicDetectionError {
  /**
   *
   * @type {string}
   * @memberof TopicDetectionError
   */
  type?: TopicDetectionErrorTypeEnum;
  /**
   * Human readable error message
   * @type {string}
   * @memberof TopicDetectionError
   */
  message?: string;
}

export const TopicDetectionErrorTypeEnum = {
  TopicDetectionFailed: 'topic_detection_failed',
  UnsupportedListOfTopics: 'unsupported_list_of_topics',
  UnsupportedLanguage: 'unsupported_language',
} as const;

export type TopicDetectionErrorTypeEnum =
  (typeof TopicDetectionErrorTypeEnum)[keyof typeof TopicDetectionErrorTypeEnum];
